import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=121a514a&"
import script from "./Inquiry.vue?vue&type=script&lang=ts&"
export * from "./Inquiry.vue?vue&type=script&lang=ts&"
import style0 from "./Inquiry.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports